import { Component } from '@angular/core';
import { IPortMissingAccountAndModel } from '@irb/irb-clients/irb-clients.model';
import { IFilterParams} from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';

@Component({ standalone: false,
  selector: 'dux-customfilter1',
  templateUrl: './customfilter.component.html',
  styleUrls: ['./customfilter.component.scss']
})
export class CustomfilterComponent  implements IFilterAngularComp {
    params: any;
    missingCountDetails: IPortMissingAccountAndModel;
    modelToolTip = 'Filter the table to show only portfolios with no model assigned.';
    accountToolTip = 'Filter the table to show only portfolios with no accounts assigned.';
    constructor() {
    }
    agInit(params: IFilterParams): void {
        this.params = params;
    }
     doesFilterPass(): boolean {
         return true;
     }
    filterMissingModel() {
        this.missingCountDetails.withoutModel = true;
        this.missingCountDetails.withoutAccount = false;
        this.missingCountDetails.taxlossResults = false;
        this.applyQuickFilter();
    }

    filterMissingAccount() {
        this.missingCountDetails.withoutModel = false;
        this.missingCountDetails.withoutAccount = true;
        this.missingCountDetails.taxlossResults = false;
        this.applyQuickFilter();
    }

    filterTlhCount()
    {
        this.missingCountDetails.taxlossResults = true;
        this.missingCountDetails.withoutModel = false;
        this.missingCountDetails.withoutAccount = false;
        this.applyQuickFilter();
    }

    applyQuickFilter() {
        this.params.api.setFilterModel({quickfilter:this.getModel()});
        this.params.filterChangedCallback();
    }
    isFilterActive(): boolean {
        return false;
     }
     getModel(): any {
            return this.missingCountDetails;
         }
     setModel(model: any): void {
            this.missingCountDetails = model;
     }
 
}
